import styled from 'styled-components';

const ScreenReaderOnly = () => {
  return <SROnly></SROnly>;
};

export default ScreenReaderOnly;

const SROnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;
